import { render, staticRenderFns } from "./dialogCustomizeThemes.vue?vue&type=template&id=c0332bb4"
import script from "./dialogCustomizeThemes.vue?vue&type=script&lang=js"
export * from "./dialogCustomizeThemes.vue?vue&type=script&lang=js"
import style0 from "./dialogCustomizeThemes.vue?vue&type=style&index=0&id=c0332bb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports